import React, {useState} from 'react';
import {Button, Card, Input, makeStyles, Spinner, Text, Title3, tokens,} from '@fluentui/react-components';
import {useApiMutation} from "../../services/useApiQuery.ts";
import {errorAtom} from "../../store.ts";
import {useSetAtom} from "jotai";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '16px',
        maxWidth: '400px',
        margin: '0 auto',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
    errorMessage: {
        color: tokens.colorPaletteRedForeground1,
    },
});

export interface AccessKeyPromptProps {
    recheckAccess: () => void;
}

export const AccessKeyPrompt: React.FC<AccessKeyPromptProps> = (props: AccessKeyPromptProps) => {
    const styles = useStyles();
    const [accessKey, setAccessKey] = useState('');
    const setError = useSetAtom(errorAtom)
    const {t} = useTranslation();

    const submitAccessKeyMutation = useApiMutation('POST', {
        onSettled: () => props.recheckAccess(),
        skipErrorNotification: true
    })

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setError("")
        submitAccessKeyMutation.mutate(
            {
                path: '/api/access/elevate',
                body: {accessKey},
            }
        )
    };

    return (
        <Card>
            <div className={styles.container}>
                <Title3>{t("text.enter-product-key")}</Title3>
                <Text>{t("text.enter-product-key-desc")}</Text>
                <form className={styles.form} onSubmit={handleSubmit}>
                    <Input
                        type="password"
                        value={accessKey}
                        onChange={(e) => setAccessKey(e.target.value)}
                        placeholder={t("placeholder.enter-product-key")}
                        required
                    />
                    <Button
                        type="submit"
                        appearance="primary"
                        disabled={submitAccessKeyMutation.isPending}
                    >
                        {submitAccessKeyMutation.isPending ? <Spinner size="tiny"/> : t("button.submit")}
                    </Button>
                    {submitAccessKeyMutation.isError && (
                        <Text className={styles.errorMessage}>
                            {t("error.invalid-access-key")}
                        </Text>
                    )}
                </form>
            </div>
        </Card>
    );
};

export default AccessKeyPrompt;